import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-vrjmof2024_white.svg'
import _imports_1 from '@/assets/images/logo-jmof_white.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-inner" }
const _hoisted_3 = { class: "footer-logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "image -vrjmof",
  src: _imports_0,
  alt: "VR JMoF"
}, null, -1)
const _hoisted_5 = { class: "footer-link" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "footer-logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.jmof.jp/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "image -jmof",
      src: _imports_1,
      alt: "JMoF"
    })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "footer-copylight" }, " © JMoF Executive Committee ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/terms" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.footerNav[_ctx.locale].terms), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/terms/privacy_policy" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.footerNav[_ctx.locale].privacyPolicy), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/faq_contact" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.footerNav[_ctx.locale].faqContact), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/credit" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.footerNav[_ctx.locale].credit), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}